export default __webpack_public_path__ + "static/media/file4.350ef875.jpg";